<!-- 服务机构-展示块 -->
<template>
<div class="info-block">
  <router-link :to="{path: '#'}" class="info-block-a">
    <div class="div-1" v-bind:style='{backgroundImage:info.imgUrl}'>
      {{info.name}}
    </div>
    <div class="div-2">{{info.intro.replace(/<[^>]*>/g,'').substring(0,80)}}</div>
  </router-link>
</div>
</template>

<script>
export default {
  name: 'JrfwInfo2',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:180px;
  padding:0px 0px 0px 20px;
  margin:8px;
  //background-color: #e6e6e6;
  border:1px solid #ddd;
  background-size: 100px auto;
  background-repeat: no-repeat;
  background-position: 10px center;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  height:80px;
  width:100%;
  padding:10px 10px 10px 70px;
  font-size:16px;
  font-weight:600;
  text-align:left;
  line-height:30px;
  color:#000;
  //background:#fff;
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: 0px center;

}

.div-2{
  position:relative;
  height:100px;
  font-size:12px;
  text-align:left;
  line-height:20px;
  color:#515151;
  padding:5px 5px 5px 0px;

}

.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/module/JrfwInfo2.vue